import request from 'request-promise-native';

export const root = "https://us-central1-pantanova-wifi-portal.cloudfunctions.net/";

export const post = (name, body, opts = {}) => request({
    method: 'POST',
    uri: root + name,
    body,
    json: true,
    ...opts
});

export const verifyToken = (token) => post('verifyFCMToken', {token});
export const temporaryAuthorizeGuest = ({mac, ap}) => post('temporaryAuthorizeGuestRequest', {mac, ap});


// WEBPACK FOOTER //
// ./src/utils/API.js